// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1101":"044f5813","2307":"865f7cb2","5226":"e226f440","5345":"523790ef","7490":"7002c59a"}[chunkId] + ".chunk.css";
};